import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory } from 'react-router-dom'

import { formatDateTime } from 'util/masks'
import { ApplicationState } from 'AppReducer'

import { deleteOrderStatus, getOrderStatusList } from '../redux/actions'

const OrderStatusList: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { orderStatusList } = useSelector((state: ApplicationState) => state.orderStatusReducer)

  function handleRemove (id: number): void {
    if (window.confirm('Tem certeza que deseja remover?')) {
      deleteOrderStatus(id)(dispatch).then(res => {
        if (res?.status === 'success') {
          history.push('/panel/order/status')
        }
      })
    }
  }

  useEffect(() => {
    getOrderStatusList()(dispatch)
  }, [dispatch])

  const gridTemplateColumns = '10px 48px 200px 1fr 200px 200px 160px'

  return (
    <div className="row justify-start margin-top-32">
      <h2><i className="fa fa-history"/> Status Cadastrados</h2>
      <div className="list">
        <div className="list-header" style={{ display: 'grid', gridTemplateColumns }}>
          <div className="row"></div>
          <div className="row"></div>
          <div className="row">Status</div>
          <div className="row">Nome</div>
          <div className="row">Criado em</div>
          <div className="row">Atualizado Em</div>
          <div className="row">Ações</div>
        </div>
        {
          orderStatusList.length === 0 &&
          <div className="list-row">
            <div className="grid-span">
              Nenhum status cadastrado
            </div>
          </div>
        }
        {
          orderStatusList.map(item => (
            <div
              key={item.id}
              className="list-row"
              style={{ display: 'grid', gridTemplateColumns, color: '#707070' }}
            >
              <div className="row" style={{ height: 62, backgroundColor: item.color }} />
              <div className="row" style={{ justifyContent: 'center' }}><i className={`fas fa-${item.icon}`}/></div>

              <div className="row">{ item.name }</div>
              <div className="row">{ item.alias }</div>

              <div className="row">{ formatDateTime(item.createdAt) }</div>
              <div className="row">{ formatDateTime(item.updatedAt, '...') }</div>
              <div className="row">
                <span
                  className="button remove margin-right-8"
                  onClick={(): void => handleRemove(item.id)}
                >
                  <i className="fa fa-trash"/>
                </span>
                <NavLink className="button grow primary" to={`/panel/order/status/${item.id}`}>
                  Editar
                </NavLink>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default OrderStatusList
